import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalClose } from '../../../../shared/reducers/ModalReducer';
import { sketchConfirmCurrentMask } from '../../../../shared/actions/SketchActions';

export const MODAL_CONFIRM_WAND = 'MODAL_CONFIRM_WAND';

class ModalConfirmWand extends React.Component {
	render() {
		let count = this.props.sketch.mask.getResultPolygonsCount();
		return (
			<div className='modal-delete-layer modal-inner-wrapper'>
				<h2 className='text-center'>create layers from mask</h2>
				<p className='text-center'>
					{count} layer{count > 1 ? 's' : ''} will be created
				</p>
				<div className='text-center'>
					<button className='btn btn-modal' onClick={this.props.modalClose}>
						cancel
					</button>
					<button
						className='btn btn-modal'
						onClick={() => {
							this.props.sketchConfirmCurrentMask();
							this.props.modalClose();
						}}>
						create
					</button>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		...ownProps,
		sketch: state.sketchState.sketch
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			sketchConfirmCurrentMask,
			modalClose
		},
		dispatch
	);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalConfirmWand);
